export default "__VITE_ASSET__G$4yrHdU__"